(() => {
  'use strict';
  const doc = document.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = window.matchMedia('(pointer: fine)').matches;
  doc.classList.add('vs-js');

  function initReveal(scope) {
    const items = [...scope.querySelectorAll('[data-reveal]')];
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) { items.forEach((el) => el.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    items.forEach((el) => {
      if (el.getBoundingClientRect().top < innerHeight) { el.classList.add('is-in'); return; }
      if (!el.style.getPropertyValue('--i')) {
        const siblings = [...el.parentElement.children].filter((c) => c.hasAttribute('data-reveal'));
        el.style.setProperty('--i', Math.min(siblings.indexOf(el), 6));
      }
      io.observe(el);
    });
  }

  function initCatalog(scope) {
    scope.querySelectorAll('[data-vs-catalog]').forEach((catalog) => {
      if (catalog.dataset.vsReady) return;
      catalog.dataset.vsReady = '1';
      const buttons = [...catalog.querySelectorAll('[data-vs-filter]')];
      const items = [...catalog.querySelectorAll('[data-vs-item]')];
      const count = catalog.querySelector('[data-vs-count]');
      const empty = catalog.querySelector('[data-vs-empty]');
      const apply = (key) => {
        let shown = 0;
        items.forEach((item) => {
          const visible = key === 'all' || (item.dataset.vsCats || '').split(' ').includes(key);
          item.hidden = !visible;
          if (visible) { shown++; item.classList.add('is-in'); }
        });
        buttons.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.vsFilter === key)));
        if (count) count.textContent = String(shown);
        if (empty) empty.hidden = shown > 0;
      };
      buttons.forEach((b) => b.addEventListener('click', () => apply(b.dataset.vsFilter)));
      apply('all');
    });
  }

  function initMenu() {
    const menu = document.querySelector('.vs-menu');
    const header = document.querySelector('.vs-header');
    if (!menu || !header) return;
    const place = () => doc.style.setProperty('--vs-menu-top', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
    menu.addEventListener('toggle', () => { if (menu.open) place(); });
    window.addEventListener('resize', () => { if (menu.open) place(); }, { passive: true });
  }

  function initAnnounce() {
    const items = [...document.querySelectorAll('[data-announce]')];
    if (items.length < 2) { items.forEach((i) => i.classList.add('is-on')); return; }
    let i = 0;
    items[0].classList.add('is-on');
    if (reduce) return;
    setInterval(() => {
      if (document.hidden) return;
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }, 4800);
  }

  function initStory(scope) {
    scope.querySelectorAll('[data-story]').forEach((story) => {
      const steps = [...story.querySelectorAll('.vs-step')];
      const bar = story.querySelector('.vs-story__progress');
      if (!steps.length) return;
      const activate = (idx) => {
        steps.forEach((s, n) => s.classList.toggle('is-active', n === idx));
        if (bar) bar.style.setProperty('--p', String((idx + 1) / steps.length));
      };
      if (reduce || !('IntersectionObserver' in window)) { steps.forEach((s) => s.classList.add('is-active')); return; }
      activate(0);
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => { if (entry.isIntersecting) activate(steps.indexOf(entry.target)); });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach((s) => io.observe(s));
    });
  }

  function initGlow(scope) {
    if (!fine || reduce) return;
    scope.querySelectorAll('.vs-glow').forEach((el) => {
      el.addEventListener('pointermove', (e) => {
        const r = el.getBoundingClientRect();
        el.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        el.style.setProperty('--my', (e.clientY - r.top) + 'px');
      });
    });
  }

  function initStage() {
    const stage = document.querySelector('[data-stage]');
    if (!stage || !fine || reduce) return;
    const cards = [...stage.querySelectorAll('[data-depth]')];
    let frame = 0;
    stage.addEventListener('pointermove', (e) => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const r = stage.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        cards.forEach((c) => {
          const d = parseFloat(c.dataset.depth) || 10;
          c.style.translate = `${(x * d).toFixed(1)}px ${(y * d).toFixed(1)}px`;
        });
      });
    });
    stage.addEventListener('pointerleave', () => cards.forEach((c) => { c.style.translate = ''; }));
  }

  function initCopy() {
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-copy]');
      if (!btn) return;
      const value = btn.getAttribute('data-copy');
      try { await navigator.clipboard.writeText(value); } catch (err) {
        const t = document.createElement('textarea'); t.value = value; document.body.appendChild(t); t.select();
        try { document.execCommand('copy'); } catch (e2) {}
        t.remove();
      }
      const label = btn.querySelector('[data-copy-label]');
      const prev = label ? label.textContent : '';
      btn.classList.add('is-done');
      if (label) label.textContent = btn.getAttribute('data-copied') || 'Copiado';
      setTimeout(() => { btn.classList.remove('is-done'); if (label) label.textContent = prev; }, 2200);
    });
  }

  function slug(text, used) {
    let s = text.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'seccion';
    let out = s, n = 2;
    while (used.has(out)) out = s + '-' + n++;
    used.add(out);
    return out;
  }

  function initToc() {
    const body = document.querySelector('[data-toc-src]');
    if (!body) return;
    const used = new Set();
    const heads = [...body.querySelectorAll('h2')];
    heads.forEach((h) => { if (!h.id) h.id = slug(h.textContent, used); });
    const list = document.querySelector('[data-toc]');
    if (list && heads.length > 1) {
      heads.forEach((h) => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = '#' + h.id; a.textContent = h.textContent;
        li.appendChild(a); list.appendChild(li);
      });
      list.closest('.vs-toc').hidden = false;
      if ('IntersectionObserver' in window) {
        const links = [...list.querySelectorAll('a')];
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            links.forEach((l) => l.classList.toggle('is-current', l.getAttribute('href') === '#' + entry.target.id));
          });
        }, { rootMargin: '0px 0px -75% 0px' });
        heads.forEach((h) => io.observe(h));
      }
    }
    const faqHead = heads.find((h) => /preguntas frecuentes/i.test(h.textContent));
    if (faqHead) {
      const qa = [];
      let el = faqHead.nextElementSibling;
      while (el && el.tagName !== 'H2') {
        if (el.tagName === 'H3') {
          let answer = '';
          let next = el.nextElementSibling;
          while (next && !/^H[23]$/.test(next.tagName)) { answer += ' ' + next.textContent.trim(); next = next.nextElementSibling; }
          if (answer.trim()) qa.push({ '@type': 'Question', name: el.textContent.trim(), acceptedAnswer: { '@type': 'Answer', text: answer.trim() } });
        }
        el = el.nextElementSibling;
      }
      if (qa.length) {
        const s = document.createElement('script');
        s.type = 'application/ld+json';
        s.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: qa });
        document.head.appendChild(s);
      }
    }
  }

  const start = () => {
    if ('IntersectionObserver' in window) {
      const animated = document.querySelectorAll('.vs-stage, .vs-ticker, .vs-logos');
      const visibility = new WeakMap();
      const update = el => el.classList.toggle('vs-motion-paused', document.hidden || !visibility.get(el));
      const observer = new IntersectionObserver(entries => entries.forEach(entry => { visibility.set(entry.target, entry.isIntersecting); update(entry.target); }), {rootMargin:'100px'});
      animated.forEach(el => observer.observe(el));
      document.addEventListener('visibilitychange', () => animated.forEach(update));
    }
    initReveal(document); initCatalog(document); initMenu(); initAnnounce();
    initStory(document); initGlow(document); initStage(); initCopy(); initToc();
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
  document.addEventListener('shopify:section:load', (e) => { initReveal(e.target); initCatalog(e.target); initStory(e.target); initGlow(e.target); });
})();
